import { NavLink, Outlet } from "react-router-dom";
import { useState } from "react";
import { Users, Settings as Cog, ScrollText, FileText, Trophy } from "lucide-react";
import { getStaff, setStaff } from "@/lib/api";

const NAV = [
  { to: "/clients", label: "Clients", icon: Users, id: "nav-clients" },
  { to: "/results", label: "Results log", icon: Trophy, id: "nav-results" },
  { to: "/audit", label: "Audit log", icon: ScrollText, id: "nav-audit" },
  { to: "/settings", label: "Settings", icon: Cog, id: "nav-settings" },
];

export default function Layout() {
  const [name, setName] = useState(getStaff());
  return (
    <div className="min-h-screen flex">
      <aside className="w-56 shrink-0 border-r border-border bg-[#0D121C] flex flex-col">
        <div className="px-5 py-6 flex items-center gap-2">
          <div className="h-8 w-8 rounded-lg bg-blue-600 grid place-items-center"><FileText size={16} /></div>
          <div>
            <div className="font-display font-bold leading-tight">Base Resume</div>
            <div className="text-[11px] text-muted-foreground">BulkJobApply</div>
          </div>
        </div>
        <nav className="px-3 space-y-1 flex-1">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} data-testid={n.id}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-2 rounded-lg text-sm transition-colors ${isActive ? "bg-blue-600/15 text-blue-300" : "text-slate-400 hover:bg-slate-800/60 hover:text-slate-200"}`}>
              <n.icon size={16} /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-border">
          <div className="label-xs mb-1">Working as</div>
          <input data-testid="staff-name-input" value={name} placeholder="Your name"
            onChange={(e) => { setName(e.target.value); setStaff(e.target.value); }}
            className="w-full bg-slate-900 border border-border rounded-md px-2 py-1.5 text-sm outline-none focus:border-blue-500" />
          <div className="text-[10px] text-muted-foreground mt-1">Recorded in the audit log. Login comes later.</div>
        </div>
      </aside>
      <main className="flex-1 min-w-0"><Outlet /></main>
    </div>
  );
}
